<div
  class="label-container pointer"
  [ngClass]="{'scaled, social-media-styles' : icon,
                'active' : active}"
  (click)="onSelect()">
  <div
    *ngIf="!icon"
    class="ts-sprite global-transition"
    [ngClass]="{'bg-page' : id === 1,
            'bg-blog' : id === 2,
            'bg-forum' : id === 3,
            'bg-social' : id === 4,
            'bg-mailing' : id === 5,
            'bg-mobile' : id === 6,
            'bg-ppc' : id === 7,
            'bg-other' : id === 8,
            'bg-network' : id === 34}"></div>
  <div *ngIf="icon" class="icon-container global-transition" [ngClass]="getBgClass(icon)">
    <img src="{{setSocialMediaIcon()}}" />
  </div>
  <h6 class="fontsize14 font500">{{'traffic_source_types.' + id | translate}}</h6>
</div>
